(window.onunload = function () {}),
  window.addEventListener("pageshow", function (o) {
    o.persisted && window.location.reload();
  }),
  $(function () {
    $("html,body")
      .stop()
      .animate(
        {
          scrollTop: 0,
        },
        100
      )
      .promise()
      .done(function () {
        $(window).trigger("prodPageReady");
      });
  }),
  $(window).on("beforeunload pagehide", function (o) {
    $(".c-loading").show(),
      $("html,body").stop().animate(
        {
          scrollTop: 0,
        },
        10
      );
  }),
  $(window).on("prodPageReady", function () {
    // ローディング画面を閉じる
    $(".c-loading").fadeOut(500);

    const o = window.matchMedia("(min-width: 768px)"),
      t = !o.matches;

    function e(o) {
      const t = !o.matches;
      $(".js-videoImageChange").each(function () {
        const o = $(this).data(t ? "sp" : "pc");
        $(this).attr("src", o);
      });
    }
    o.addEventListener("change", e), e(o);
    const n = document.querySelector(".prod-city-sideslide_list"),
      r = gsap.utils.toArray(".prod-city-sideslide_item");
    // gsap.to(r, {
    // 	xPercent: -100 * (r.length - 1),
    // 	ease: "none",
    // 	scrollTrigger: {
    // 		trigger: n,
    // 		pin: !0,
    // 		scrub: 1,
    // 		end: () => "+=" + n.offsetWidth
    // 	}
    // }),
    gsap
      .timeline({
        scrollTrigger: {
          trigger: ".prod-city-batt_over",
          start: "top center",
        },
      })
      .from(".prod-city-batt_lead", {
        opacity: 0,
        duration: 0.5,
      })
      .from(".prod-city-batt_desc", {
        opacity: 0,
        duration: 0.5,
      })
      .from(".prod-city-batt_spec", {
        opacity: 0,
        duration: 0.5,
      })
      .from(".prod-city-batt_notice", {
        opacity: 0,
        duration: 0.5,
      }),
      gsap
        .timeline({
          scrollTrigger: {
            trigger: ".prod-city-fold",
            start: "top center",
          },
        })
        .from(".prod-city-fold_lead", {
          opacity: 0,
          duration: 1,
        })
        .from(
          ".prod-city-fold_desc",
          {
            opacity: 0,
            duration: 1,
          },
          "-=0.8"
        )
        .from(".prod-city-fold_spec", {
          opacity: 0,
          duration: 1,
        }),
      $(".js-prod-cmn-colorSlider").slick({
        arrow: !0,
        dots: !0,
        fade: !0,
      });
    gsap
      .timeline({
        ease: "none",
        scrollTrigger: {
          trigger: ".prod-cmn-color2",
          start: "top center",
          once: !0,
        },
      })
      .set(".prod-cmn-colorOp_head", {
        y: 20,
      })
      .set(".prod-cmn-colorOp_lead", {
        y: 20,
      })
      .set(".prod-cmn-color_slideName", {
        opacity: 0,
        y: 20,
      })
      .set(".prod-cmn-color2 .slick-arrow", {
        opacity: 0,
      })
      .set(".prod-cmn-color2 .slick-dots", {
        opacity: 0,
      })
      .to(".prod-cmn-colorOp_head", {
        opacity: 1,
        y: 0,
        duration: 0.5,
      })
      .to(".prod-cmn-colorOp_lead", {
        opacity: 1,
        y: 0,
        duration: 0.5,
      })
      .to(
        ".prod-cmn-colorOp_head, .prod-cmn-colorOp_lead",
        {
          opacity: 0,
          duration: 0.5,
        },
        "+=1"
      )
      .to(".prod-cmn-colorOp", {
        opacity: 0,
        duration: 1,
      })
      .to(".prod-cmn-color2_slideName", {
        opacity: 1,
        y: 0,
        duration: 0.5,
      })
      .to(
        ".prod-cmn-color2 .slick-arrow",
        {
          opacity: 1,
          duration: 0.5,
        },
        "-=0.5"
      )
      .to(
        ".prod-cmn-color2 .slick-dots",
        {
          opacity: 1,
          duration: 0.5,
        },
        "-=0.5"
      );
  });
